// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8830) return "static/chunks/8830-9229faf758526c83.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"508":"237a8c43daf595c9","1083":"45e517251be61273","3365":"5769564aa2ba83b6","5746":"2cb6f1f631956049","8127":"0862d2e3f7d59706","9306":"1ebcc2094632a2aa"}[chunkId] + ".js";
};